var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GoogleMap',{attrs:{"latitude":_vm.latitude,"longitude":_vm.longitude}})}
var staticRenderFns = []

export { render, staticRenderFns }